export const getEStoreCategoryList = state => {
    return state.list
}

export const getEStoreCategoryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCategory/getters.js